import { getOrderInvoice } from '@/services/user/orders';

export const handleQtyText = (qty, locale) => {
  if (locale?.includes('en')) {
    return qty === 1 ? `${qty} Product` : `${qty} Products`;
  }
  if (qty === 1) return 'منتج واحد';
  if (qty === 2) return 'منتجان';
  if (qty >= 3 && qty <= 10) return `${qty} منتجات`;
  return `${qty} منتج`;
};

export const handleOrderStatus = (status, locale) => {
  switch (status) {
    case 'new':
      return {
        state: 'new',
        text: locale?.includes('en') ? 'New' : 'جديد',
        color: '#00A31A',
      };
    case 'pending':
      return {
        state: 'pending',
        text: locale?.includes('en') ? 'Pending' : 'قيد الإنتظار',
        color: '#D19A0C',
      };
    case 'processing':
      return {
        state: 'processing',
        text: locale?.includes('en') ? 'Processing' : 'قيد التنفيذ',
        color: '#0071FF',
      };
    case 'canceled':
      return {
        state: 'canceled',
        text: locale?.includes('en') ? 'Canceled' : 'ملغي',
        color: '#FF0000',
      };
    case 'complete':
      return {
        state: 'complete',
        text: locale?.includes('en') ? 'Complete' : 'تم التسليم',
        color: '#00A31A',
      };
    case 'delivered':
      return {
        state: 'delivered',
        text: locale?.includes('en') ? 'Delivered' : 'تم التسليم',
        color: '#00A31A',
      };
    case 'pending_payment':
      return {
        state: 'pending_payment',
        text: locale?.includes('en') ? 'Pending Payment' : 'قيد الإنتظار للدفع',
        color: '#D19A0C',
      };
    case 'out_for_delivery':
      return {
        state: 'canceled',
        text: locale?.includes('en') ? 'Out For Delivery' : 'في الطريق',
        color: '#FF0000',
      };
    default:
      // return status as it's with first letter capitalized.
      return {
        state: status?.charAt(0)?.toUpperCase() + status?.slice(1),
        text: status,
        color: '#000000',
      };
  }
};

export const handlePrintOrder = async ({ customerId, orderId, mage }) => {
  const response = await getOrderInvoice({ customerId, orderId, mage });
  const blob = new Blob([response?.data], { type: 'application/pdf' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.target = '_blank';
  link.setAttribute('download', `invoice_${orderId}.pdf`); // Set the file name
  document.body.appendChild(link);
  link.click();

  // Clean up
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const getShippingMethodDuration = (shippingMethod, t) => {
  if (shippingMethod?.includes('flatrate')) {
    return t('delivery_same_day');
  } else if (shippingMethod?.includes('homedelivery_next_day')) {
    return t('delivery_next_day');
  } else {
    return t('delivery_next_three_days');
  }
};
